import { axiosInstance } from './';

const getChallenges = async (params) =>
  await axiosInstance.get('/quick_challenges', { params });

const getChallengeDetails = async (id) =>
  await axiosInstance.get(`/quick_challenges/${id}`);

const createChallenge = async (data) =>
  await axiosInstance.post('/quick_challenges', data);

const editChallenge = async ({ id, data }) =>
  await axiosInstance.patch(`/quick_challenges/${id}`, data);

const duplicateChallenge = async (id) =>
  await axiosInstance.post(`/challenges/${id}/duplicate`);

const publishChallenge = async ({ id, data }) =>
  await axiosInstance.patch(`quick_challenges/${id}/publish`, data);

const saveChallengeAsDraft = async (data) =>
  await axiosInstance.post('/challenges/drafts', data);

const deleteDraft = async (id) =>
  await axiosInstance.delete(`/challenges/drafts/${id}`);

const getChallengeUsers = async (params) =>
  await axiosInstance.get('/quick_challenge_completions', { params });

// Rewards list (post-submission)
const getChallengeRewards = async (params) =>
  await axiosInstance.get('/quick_challenge_rewards', { params });

const submitChallengeSelection = async ({ id, data }) =>
  await axiosInstance.post(`quick_challenges/${id}/submit_rewards`, data);

export {
  getChallenges,
  getChallengeDetails,
  createChallenge,
  editChallenge,
  duplicateChallenge,
  publishChallenge,
  saveChallengeAsDraft,
  deleteDraft,
  getChallengeUsers,
  getChallengeRewards,
  submitChallengeSelection,
};
